<ng-container *ngIf="profile$ | async as profile">
  <section
    *ngIf="profile.isImpersonating"
    class="impersonation-banner"
    role="status"
    aria-live="polite"
  >
    <div class="impersonation-banner__content">
      <div class="impersonation-banner__text">
        <h2 class="impersonation-banner__title"> Impersonation Mode! </h2>

        <p class="impersonation-banner__description">
          You are signed in as
          <strong>
            {{ profile.effectiveUser?.firstName }}
            {{ profile.effectiveUser?.lastName }}
          </strong>

          <ng-container *ngIf="profile.effectiveUser?.email">
            ({{ profile.effectiveUser?.email }})
          </ng-container>.
          Actions you perform will affect this user's account.
        </p>

        <div
          *ngIf="errorMessage"
          class="impersonation-banner__error"
          role="alert"
        >
          {{ errorMessage }}
        </div>
      </div>

      <button
        type="button"
        class="impersonation-banner__button"
        [disabled]="isEnding"
        (click)="returnToAdminAccount()"
      >
        {{ isEnding ? 'RETURNING...' : 'RETURN TO MY ACCOUNT' }}
      </button>
    </div>
  </section>
</ng-container>